import { configureStore } from '@reduxjs/toolkit';
import { playerSlice } from './slices/player-list/playerSlice';
import { partnerSlice } from './slices/partner-list/partnerSlice';
import { licenseSlice } from './slices/license-list/licenseSlice';
import { languageSlice } from './slices/languageSlice';

export const stores = configureStore({
  reducer: {
    license: licenseSlice.reducer,
    player: playerSlice.reducer,
    partner: partnerSlice.reducer,
    language: languageSlice.reducer,
  },
});

export type RootState = ReturnType<typeof stores.getState>;
export type AppDispatch = typeof stores.dispatch;
